import axios from "axios";
import moment from "moment";
import ReactPlayer from "react-player";
import sakibal from "../../Assets/Images/Profile/shakib-message.jpg";
import ShakibProfile from "../../Assets/Images/Profile/Shakib-profile.jpg";
import raihanProfileImage from "../../Assets/Images/raihanProfile.jpg";
import noImage from "../../Assets/Images/settings/no-image.png";

import LeftCardPhotos from "../../components/UserProfile/LaftCardPhotos";
import LeftCardVideos from "../../components/UserProfile/LaftCardVideos";
import RightSideCard from "../../components/UserProfile/RightSideCard";
import UserInformation from "../../components/UserProfile/UserInformation";
import InfiniteScroll from "react-infinite-scroll-component";
import SkeletonArticle from "../../components/Post_skaliton/SkeletonArticle";

import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navigation from "../../components/Layouts/Header/Navigation";
import { serverInfo } from "../../App";

const UserProfile = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const params = useParams();
  const [messagenger, setMessenger] = useState(false);
  const [user, setUser] = useState([]);
  const [profileImage, setProfileImage] = useState("");
  const [coverPhoto, setCoverPhoto] = useState("");
  const [userActivites, setUserActivites] = useState([]);
  const [paginate, setPaginate] = useState(1);
  const [loader, setLoader] = useState(true);

  function handleClick() {
    setMessenger(!messagenger);
  }


  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`/api/user_info/${params?.user_id}`).then((res) => {
        if (res.status === 200) {
          setUser(res.data.users);

          setProfileImage(
            res.data.users.image !== null
              ? imageCdnUrl + res.data.users.image
              : noImage
          );
          setCoverPhoto(
            res.data.users.cover_photo !== null
              ? imageCdnUrl + res.data.users.cover_photo
              : noImage
          );
        }
      });
  }, [params.user_id]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    axios
      .get(
        `/api/user/${params.user_id}/activitiesData/with-paginate/5?page=${paginate}`
      )
      .then((res) => {
        if (res.status === 200) {
          setUserActivites([...userActivites, ...res.data.userActivites?.data]);
          setPaginate(paginate + 1);
          setLoader(false);
        }
      });
  };

  return (
    <>
      <Navigation />
      <div className="full-container py-3 ">
        <div className="container mb-2">
          <div className="profile-img-cover ">
            <div className="profile-container">
              <img
                src={coverPhoto}
                className="img-fluid profile-cover"
                alt="cover_photo"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://timelinecovers.pro/facebook-cover/download/life-cycle-facebook-cover.jpg";
                }}
              />
            </div>
          </div>
          <div className="profile-div mb-5">
            <div className="profile-photo">
              <div className="d-flex justify-content-center">
                <img
                  src={profileImage}
                  alt={raihanProfileImage}
                  className="img-fluid profile-img"
                />
              </div>

              <div className="bottomright-profile"></div>

              <div className="prodile-pic-info text-center mt-3">
                <h5 className="profile-font-color-head">
                  {user?.first_name} {user?.last_name}
       
                </h5>
                {user && (
                  <h6 className="profile-font-color-head-copy">
                    {" "}
                    @hss_{user?.id}
                  </h6>
                )}
              </div>
            </div>
          </div>

          <div className="container main-div">
            <div className="row">
              <div className="col-md-5 user-left-top-margin">
                <div className="leftSide-user-sticky">
                  <div className="leftSide-user-sticky-scroll">
                    {user.user_info ? <UserInformation userInfo={user} /> : ""}

                    <LeftCardPhotos title="Photos" photos={userActivites} />
                    <div className="mt-3">
                      <LeftCardVideos title="Videos" videos={userActivites} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-7 right-card-profile">
                {loader &&
                  [1, 2, 3, 4].map(() => <SkeletonArticle theme="dark" />)}

                <InfiniteScroll
                  dataLength={userActivites.length}
                  next={fetchData}
                  hasMore={true}
                  loader={
                    <h4 className="text-center text-warning">Loading...</h4>
                  }
                  endMessage={
                    <p style={{ textAlign: "center" }}>
                      <b>You have seen it all</b>
                    </p>
                  }
                >
                  {userActivites.map((activity) => (
                    <>
                      {activity?.type === "meetup" ? (
                        <RightSideCard
                          Name={
                            activity?.meetup?.star?.first_name +
                            " " +
                            activity?.meetup?.star?.last_name
                          }
                          Msg={moment(
                            activity?.meetup?.start_time,
                            "HH:mm"
                          ).format("hh:mm A")}
                          CreateTime={moment(
                            activity?.meetup?.created_at
                          ).format("LL")}
                          title={activity?.meetup?.title}
                          profileImg={
                            activity?.meetup?.banner != null
                              ? imageCdnUrl + activity?.meetup?.banner
                              : null
                          }
                          profileLogo={
                            activity?.meetup?.star?.image != null
                              ? imageCdnUrl + activity?.meetup?.star?.image
                              : null
                          }
                        />
                      ) : activity?.type === "learningSession" ? (
                        <RightSideCard
                          Name={
                            activity?.learning_session?.star?.first_name +
                            " " +
                            activity?.learning_session?.star?.last_name
                          }
                          Msg={moment(
                            activity?.learning_session?.start_time,
                            "HH:mm"
                          ).format("hh:mm A")}
                          CreateTime={moment(
                            activity?.learning_session?.created_at
                          ).format("LL")}
                          title={activity?.learning_session?.title}
                          profileImg={
                            activity?.learning_session?.banner != null
                              ? imageCdnUrl + activity?.learning_session?.banner
                              : null
                          }
                          profileLogo={
                            activity?.learning_session?.star?.image != null
                              ? imageCdnUrl +
                              activity?.learning_session?.star?.image
                              : null
                          }
                        />
                      ) : activity?.type === "greeting" &&
                        activity?.greeting_registration?.status > 2 &&
                        activity?.greeting_registration?.video !== null ? (
                        <RightSideCard
                          Name={
                            activity?.greeting?.star?.first_name +
                            " " +
                            activity?.greeting?.star?.last_name
                          }
                          Msg={moment(
                            activity?.greeting_registration?.request_time,
                            "HH:mm"
                          ).format("hh:mm A")}
                          CreateTime={moment(
                            activity?.greeting_registration?.request_time
                          ).format("LL")}
                          title={activity?.greeting?.title}
                          video={
                            activity?.greeting_registration?.video != null
                              ? videoCdnUrl +
                              activity?.greeting_registration?.video
                              : null
                          }
                          profileLogo={
                            activity?.greeting?.star?.image !== null
                              ? imageCdnUrl + activity?.greeting?.star?.image
                              : noImage
                          }
                          id={activity?.greeting?.id}
                        />
                      ) : activity?.type === "liveChat" ? (
                        <RightSideCard
                          Name={
                            activity?.livechat?.star?.first_name +
                            " " +
                            activity?.livechat?.star?.last_name
                          }
                          Msg={moment(
                            activity?.livechat?.start_time,
                            "HH:mm"
                          ).format("hh:mm A")}
                          CreateTime={moment(
                            activity?.livechat?.created_at
                          ).format("LL")}
                          title={activity?.livechat?.title}
                          profileImg={
                            activity?.livechat?.banner != null
                              ? imageCdnUrl + activity?.livechat?.banner
                              : null
                          }
                          profileLogo={ShakibProfile}
                        />
                      ) : activity?.type === "marketplace" ? (
                        <RightSideCard
                          Name={
                            activity?.meetup?.star?.first_name +
                            " " +
                            activity?.meetup?.star?.last_name
                          }
                          Msg={moment(
                            activity?.meetup?.start_time,
                            "HH:mm"
                          ).format("hh:mm A")}
                          CreateTime={moment(
                            activity?.meetup?.created_at
                          ).format("LL")}
                          title={activity?.meetup?.title}
                          profileImg={
                            activity?.meetup?.banner != null
                              ? imageCdnUrl + activity?.meetup?.banner
                              : null
                          }
                          profileLogo={
                            activity?.meetup?.star?.image != null
                              ? imageCdnUrl + activity?.meetup?.star?.image
                              : null
                          }
                        />
                      ) : null}
                    </>
                  ))}
                </InfiniteScroll>

                {/* Right side card end */}
              </div>
            </div>
          </div>
        </div>

        {/* Messaging start */}
        <div className="bottomleft-message d-flex ">
          <i
            onClick={handleClick}
            className="fab fa-facebook-messenger text-warning fa-4x bottomleft-icon"
          ></i>

          {messagenger ? (
            <div className="card mx-5 message-card">
              <div className="head m-0 p-2 d-flex justify-content-around align-items-center">
                <img
                  src={sakibal}
                  className="img-fluid rounded-circle"
                  height="40px"
                  width="40px"
                  alt=""
                />
                <span className="text-light fw-bold">Sakib Al Hasan</span>
                <i
                  className="fas fa-times-circle close-message text-light"
                  onClick={() => setMessenger(false)}
                ></i>
              </div>
              <div className="card-body">
                <img
                  src={sakibal}
                  className="img-fluid rounded-circle"
                  height="40px"
                  width="40px"
                  alt=""
                />
                <div className="d-flex">
                  <ReactPlayer
                    url="https://www.youtube.com/watch?v=3CaBNtaTrbo"
                    playing={false}
                    volume={1}
                    width="60%"
                    height="130px"
                  />
                  <i className="fas fa-share mx-2"></i>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default UserProfile;
